var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcsdashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4086 16.2139C11.25 15.8311 11.25 15.3457 11.25 14.375C11.25 13.4042 11.25 12.9189 11.4086 12.5361C11.62 12.0256 12.0256 11.62 12.5361 11.4086C12.9189 11.25 13.4042 11.25 14.375 11.25C15.3457 11.25 15.8311 11.25 16.2139 11.4086C16.7244 11.62 17.13 12.0256 17.3414 12.5361C17.5 12.9189 17.5 13.4042 17.5 14.375C17.5 15.3457 17.5 15.8311 17.3414 16.2139C17.13 16.7244 16.7244 17.13 16.2139 17.3414C15.8311 17.5 15.3457 17.5 14.375 17.5C13.4042 17.5 12.9189 17.5 12.5361 17.3414C12.0256 17.13 11.62 16.7244 11.4086 16.2139Z",
    stroke: "#009391",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4086 7.46392C11.25 7.08107 11.25 6.59571 11.25 5.625C11.25 4.65429 11.25 4.16893 11.4086 3.78608C11.62 3.2756 12.0256 2.87003 12.5361 2.65858C12.9189 2.5 13.4042 2.5 14.375 2.5C15.3457 2.5 15.8311 2.5 16.2139 2.65858C16.7244 2.87003 17.13 3.2756 17.3414 3.78608C17.5 4.16893 17.5 4.65429 17.5 5.625C17.5 6.59571 17.5 7.08107 17.3414 7.46392C17.13 7.9744 16.7244 8.38 16.2139 8.59142C15.8311 8.75 15.3457 8.75 14.375 8.75C13.4042 8.75 12.9189 8.75 12.5361 8.59142C12.0256 8.38 11.62 7.9744 11.4086 7.46392Z",
    stroke: "#009391",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65858 16.2139C2.5 15.8311 2.5 15.3457 2.5 14.375C2.5 13.4042 2.5 12.9189 2.65858 12.5361C2.87003 12.0256 3.2756 11.62 3.78608 11.4086C4.16893 11.25 4.65429 11.25 5.625 11.25C6.59571 11.25 7.08107 11.25 7.46392 11.4086C7.9744 11.62 8.38 12.0256 8.59142 12.5361C8.75 12.9189 8.75 13.4042 8.75 14.375C8.75 15.3457 8.75 15.8311 8.59142 16.2139C8.38 16.7244 7.9744 17.13 7.46392 17.3414C7.08107 17.5 6.59571 17.5 5.625 17.5C4.65429 17.5 4.16893 17.5 3.78608 17.3414C3.2756 17.13 2.87003 16.7244 2.65858 16.2139Z",
    stroke: "#009391",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.65858 7.46392C2.5 7.08107 2.5 6.59571 2.5 5.625C2.5 4.65429 2.5 4.16893 2.65858 3.78608C2.87003 3.2756 3.2756 2.87003 3.78608 2.65858C4.16893 2.5 4.65429 2.5 5.625 2.5C6.59571 2.5 7.08107 2.5 7.46392 2.65858C7.9744 2.87003 8.38 3.2756 8.59142 3.78608C8.75 4.16893 8.75 4.65429 8.75 5.625C8.75 6.59571 8.75 7.08107 8.59142 7.46392C8.38 7.9744 7.9744 8.38 7.46392 8.59142C7.08107 8.75 6.59571 8.75 5.625 8.75C4.65429 8.75 4.16893 8.75 3.78608 8.59142C3.2756 8.38 2.87003 7.9744 2.65858 7.46392Z",
    stroke: "#009391",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcsdashboard);
export default __webpack_public_path__ + "static/media/icsdashboard.61523fd50a3aefbf19b5c8cc7ab581eb.svg";
export { ForwardRef as ReactComponent };